import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	getPersonById,
	getPersonByIdEndpoint,
	type QueryError,
	type GetPersonByIdResult,
	type GetPersonByIdRequestOptions,
} from '../getPersonById';
export * from '../getPersonById';

export type GetPersonByIdQueryParams = GetPersonByIdRequestOptions;
export type GetPersonByIdQueryKey = [string, GetPersonByIdQueryParams];

export type GetPersonByIdReactQueryOptions = Omit<
	UseQueryOptions<
		GetPersonByIdResult,
		QueryError,
		GetPersonByIdResult,
		GetPersonByIdQueryKey
	>,
	'queryKey' | 'queryFn'
>;

export const GetPersonByIdReactQueryKey = getPersonByIdEndpoint;

/**
 * react-query wrapper for `getPersonById`
 * @param queryKeyParams Params passed to the api call
 * @param options Options passed to `useQuery`
 */
export const useReactQueryGetPersonById = (
	queryKeyParams: GetPersonByIdQueryParams,
	options?: GetPersonByIdReactQueryOptions,
) =>
	useQuery<
		GetPersonByIdResult,
		QueryError,
		GetPersonByIdResult,
		GetPersonByIdQueryKey
	>({
		queryFn: ({signal}) => getPersonById(queryKeyParams, signal),
		queryKey: [getPersonByIdEndpoint, queryKeyParams],
		...options,
	});
